angular.module('unica_relator.relator_services')

.factory('RelatorDeleteService', function ($http, getBaseApiURL) {

	var relatorDeleteService = {};

	relatorDeleteService.delete = function (relatorId)
	{
		return $http({
			method: 'DELETE',
			url: getBaseApiURL + '/relator/delete/' + relatorId,
			data: { }
		}).then(function(result) {

			if ( result ) {
				return true;
			}

		});
	};

	return relatorDeleteService;
});